module.exports = __webpack_public_path__ + "img/微信公众号小程序开发.8ce0c72f.png";